// Mock data for Remax Faro Landing Page

export const agentInfo = {
  name: "Rustem",
  title: "Consultor Imobiliário",
  email: "rustem.rusu@remax.pt",
  phone: "+351 931 869 111",
  photo: "https://customer-assets.emergentagent.com/job_imoveis-faro-pt/artifacts/tfzuqfkk_8D3A9580.JPG",
  license: "AMI xxxxx",
  office: "RE/MAX Platina",
  location: "Portimão, Algarve",
  slogan: "Vamos Transformar Sonhos em Endereços"
};

export const propertyTypes = [
  { value: "apartamento", label: "Apartamento" },
  { value: "moradia", label: "Moradia" },
  { value: "terreno", label: "Terreno" },
  { value: "comercial", label: "Comercial" },
  { value: "outro", label: "Outro" }
];

export const budgetRanges = [
  { value: "0-150k", label: "Até 150.000€" },
  { value: "150k-300k", label: "150.000€ - 300.000€" },
  { value: "300k-500k", label: "300.000€ - 500.000€" },
  { value: "500k-1m", label: "500.000€ - 1.000.000€" },
  { value: "1m+", label: "Mais de 1.000.000€" }
];

export const bedroomOptions = [
  { value: "1", label: "T1" },
  { value: "2", label: "T2" },
  { value: "3", label: "T3" },
  { value: "4", label: "T4" },
  { value: "5+", label: "T5+" }
];

export const faroLocations = [
  { value: "portimao-centro", label: "Portimão Centro" },
  { value: "praia-rocha", label: "Praia da Rocha" },
  { value: "alvor", label: "Alvor" },
  { value: "mexilhoeira-grande", label: "Mexilhoeira Grande" },
  { value: "lagos", label: "Lagos" },
  { value: "albufeira", label: "Albufeira" },
  { value: "lagoa", label: "Lagoa" },
  { value: "silves", label: "Silves" },
  { value: "carvoeiro", label: "Carvoeiro" },
  { value: "ferragudo", label: "Ferragudo" },
  { value: "outro", label: "Outro no Algarve" }
];

export const mainFactors = [
  { value: "localizacao", label: "Localização" },
  { value: "condicao", label: "Condição do imóvel" },
  { value: "vista", label: "Vista" },
  { value: "proximidade-praia", label: "Proximidade à praia" },
  { value: "espaco", label: "Espaço/Tamanho" },
  { value: "investimento", label: "Potencial de investimento" },
  { value: "outro", label: "Outro" }
];

export const testimonials = [
  {
    name: "Cliente RE/MAX Platina",
    text: "Profissionalismo do início ao fim. Encontrámos a casa ideal em poucas semanas e todo o processo foi acompanhado com transparência. Recomendo vivamente.",
    rating: 5,
    location: "Portimão"
  },
  {
    name: "Cliente RE/MAX Platina",
    text: "Vendemos o nosso apartamento muito acima das nossas expectativas. Excelente apoio na divulgação, negociação e tratamento de toda a burocracia.",
    rating: 5,
    location: "Praia da Rocha"
  },
  {
    name: "Cliente RE/MAX Platina",
    text: "Equipa simpática, disponível e que conhece muito bem o mercado do Algarve. Senti-me sempre seguro durante toda a compra. Sem dúvida uma referência em Portimão.",
    rating: 5,
    location: "Alvor"
  }
];

export const services = [
  {
    title: "Compra de Imóveis",
    description: "Encontre o imóvel perfeito em Portimão e Algarve. Acompanhamento personalizado em todas as etapas.",
    icon: "Home",
    image: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhcGFydG1lbnR8ZW58MHx8fHwxNzc5OTc3NjgzfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    title: "Venda de Imóveis",
    description: "Venda o seu imóvel pelo melhor preço. Marketing profissional e vasta rede de compradores.",
    icon: "TrendingUp",
    image: "https://images.unsplash.com/photo-1614807254023-133d1a7a3c41?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxQb3J0dWd1ZXNlJTIwaG91c2V8ZW58MHx8fHwxNzc5OTc3NjgzfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    title: "Avaliação Gratuita",
    description: "Avaliação profissional do seu imóvel sem compromisso. Conheça o valor real do seu património.",
    icon: "Calculator",
    image: "https://images.unsplash.com/photo-1712497867605-cd8d80574245?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxGYXJvJTIwUG9ydHVnYWx8ZW58MHx8fHwxNzc5OTc3NjgzfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    title: "Consultoria Especializada",
    description: "Apoio completo em financiamento, documentação e processo legal de compra e venda no Algarve.",
    icon: "FileText",
    image: "https://images.pexels.com/photos/27075286/pexels-photo-27075286.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  }
];

export const stats = [
  { value: "1000+", label: "Imóveis Vendidos" },
  { value: "98%", label: "Clientes Satisfeitos" },
  { value: "10", label: "Anos de História" },
  { value: "#1", label: "Rede em Portugal" }
];

// Mock function to simulate form submission
export const submitSimpleForm = async (formData) => {
  console.log("Formulário simples enviado:", formData);
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  return { success: true, message: "Obrigado! Entraremos em contacto em breve." };
};

export const submitDetailedForm = async (formData) => {
  console.log("Formulário detalhado enviado:", formData);
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  return { success: true, message: "Recebemos o seu pedido! Iremos analisar e contactá-lo brevemente." };
};
